import { useState, useEffect } from 'react';
import { differenceInSeconds } from 'date-fns';

export function Countdown({
  until,
  className,
}: {
  until: Date;
  className?: string;
}) {
  const [timeLeft, setTimeLeft] = useState<string>('-');

  useEffect(() => {
    const doTheThang = () => {
      const now = new Date();
      const diff = differenceInSeconds(until, now);
      setTimeLeft(formatSecondsToTime(diff));
    };
    const interval = setInterval(() => {
      doTheThang();
    }, 1000);

    doTheThang();

    return () => clearInterval(interval);
  }, [until]);

  return <div className={className}>{timeLeft}</div>;
}

function formatSecondsToTime(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}
